import { render, staticRenderFns } from "./LinkMenu.vue?vue&type=template&id=1400df61&scoped=true&"
import script from "./LinkMenu.vue?vue&type=script&lang=js&"
export * from "./LinkMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400df61",
  null
  
)

export default component.exports